import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import { numberFormat } from 'helper';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import LandSupersededAssessmentModal from '../component/LandSupersededAssessmentModal';
import * as actions from '../../../action';
import * as c from '../../../constant';

function LandSupersededAssessment({
  getSingleLandRecordofSupAssessment,
  landSupersededAssessmentInfo,
  getLandRecordofSupAssessmentList,
  getHistoryRecordofSupAssessmentList,
  applicationId,
  applicationType,
  applicationStatus,
  historyApplicationId,
  removeLandRecordofSupAssessment,
  dataList,
  type,
  isLoading,
}) {
  const permissions = getJson('permissions');
  const setModal = useContext(ModalContext);

  const OnSetFormData = () => {
    if (!_.isEmpty(_.get(dataList, '0.id'))) {
      const id = _.get(dataList, '0.id');
      if (type !== 'history')
        getSingleLandRecordofSupAssessment(applicationId, id);
    }
  };

  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    if (type === 'history')
      getHistoryRecordofSupAssessmentList(historyApplicationId);
    else getLandRecordofSupAssessmentList(applicationId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    if (type === 'history')
      getHistoryRecordofSupAssessmentList(historyApplicationId);
    else getLandRecordofSupAssessmentList(applicationId);
  }, [applicationId]);

  useEffect(() => {
    if (dataList.length > 0) {
      OnSetFormData();
    }
  }, [dataList]);

  useEffect(() => {
    if (dataList.length > 0) {
      OnSetFormData();
    }
  }, []);

  const handleAddLandRecordofSupAssessment = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <LandSupersededAssessmentModal
          applicationId={applicationId}
          type="NEW"
        />
      ),
      title: 'Add Land Record of Superseded Assessment',
      modalSize: 'modal-md',
    });
  };

  const handleUpdateLandRecordofSupAssessment = (id, data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <LandSupersededAssessmentModal
          updateList={data.attributes}
          id={data.id}
          applicationId={id}
          type="EDIT"
        />
      ),
      title: 'Update Land Record of Superseded Assessment',
      modalSize: 'modal-md',
    });
  };

  const handleremoveLandRecordofSupAssessment = (id, data) => (e) => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure you want to remove this Land Record of Superseded Assessment?',
      () => {
        removeLandRecordofSupAssessment(id, data, () => {
          getLandRecordofSupAssessmentList(id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  return (
    <div className="">
      <div className="p-0">
        {isLoading ? (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <>
            <div className="row my-3 mx-1">
              {Acl(permissions, [
                'CREATE E2E RPT LAND RECORD OF SUPERSEDED ASSESSMENTS',
              ]) &&
                type !== 'history' &&
                applicationType !== 'TR' &&
                applicationStatus !== 'CANCELLED' && (
                  <div className="col-12 d-flex">
                    <div className="ml-auto">
                      <button
                        onClick={handleAddLandRecordofSupAssessment}
                        type="button"
                        className="btn btn-primary cms-bg-color-primary cms-outline-primary  mb-2"
                      >
                        Add Record of Superseded Assessment
                      </button>
                    </div>
                  </div>
                )}
              {dataList.map((item) => {
                return (
                  <React.Fragment key={item.id}>
                    {type !== 'history' &&
                      applicationType !== 'TR' &&
                      applicationStatus !== 'CANCELLED' && (
                        <div className="col-12 text-right">
                          {Acl(permissions, [
                            'UPDATE E2E RPT LAND RECORD OF SUPERSEDED ASSESSMENTS',
                          ]) && (
                            <button
                              type="button"
                              className="btn-blank"
                              onClick={handleUpdateLandRecordofSupAssessment(
                                applicationId,
                                landSupersededAssessmentInfo
                              )}
                            >
                              <i className="far fa-edit icon-edit" />
                            </button>
                          )}
                          {Acl(permissions, [
                            'DELETE E2E RPT LAND RECORD OF SUPERSEDED ASSESSMENTS',
                          ]) && (
                            <button
                              type="button"
                              className="btn-blank"
                              onClick={handleremoveLandRecordofSupAssessment(
                                applicationId,
                                landSupersededAssessmentInfo.id
                              )}
                            >
                              <i className="far fa-trash-alt icon-delete" />
                            </button>
                          )}
                        </div>
                      )}
                    <div className="row d-flex  mb-1 p-3">
                      <div className="col-12">
                        <table className="transaction-table table table-borderless table-striped table-sm ">
                          <tbody>
                            <tr>
                              <td
                                className="span-title2 font-weight-bold"
                                width="250"
                              >
                                PIN
                              </td>
                              <td className="text-dark" width="1" />
                              <td>{_.get(item, 'attributes.pin') || '--'}</td>
                            </tr>
                            <tr>
                              <td
                                className="span-title2 font-weight-bold"
                                width="250"
                              >
                                ARP No.
                              </td>
                              <td className="text-dark" width="1" />
                              <td>
                                {_.get(item, 'attributes.arp_no') || '--'}
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="span-title2 font-weight-bold"
                                width="250"
                              >
                                TD No.
                              </td>
                              <td className="text-dark" width="1" />
                              <td>{_.get(item, 'attributes.td_no') || '--'}</td>
                            </tr>
                            <tr>
                              <td
                                className="span-title2 font-weight-bold"
                                width="250"
                              >
                                Total Assessed Value
                              </td>
                              <td className="text-dark" width="1" />
                              <td>
                                {numberFormat(
                                  _.get(
                                    item,
                                    'attributes.total_assessed_value'
                                  ),
                                  2
                                ) || '--'}
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="span-title2 font-weight-bold"
                                width="250"
                              >
                                Previous Owner
                              </td>
                              <td className="text-dark" width="1" />
                              <td>
                                {_.get(item, 'attributes.previous_owner') ||
                                  '--'}
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="span-title2 font-weight-bold"
                                width="250"
                              >
                                Effectivity of Assessment
                              </td>
                              <td className="text-dark" width="1" />
                              <td>
                                {_.get(
                                  item,
                                  'attributes.effectivity_of_assessment'
                                ) || '--'}
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="span-title2 font-weight-bold"
                                width="250"
                              >
                                AR Page No.
                              </td>
                              <td className="text-dark" width="1" />
                              <td>
                                {_.get(item, 'attributes.ar_page_no') || '--'}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="col-12 pt-2 border-top" />
                      <div className="col-12">
                        <table className="transaction-table table table-borderless table-striped table-sm ">
                          <tbody>
                            <tr>
                              <td
                                className="span-title2 font-weight-bold"
                                width="250"
                              >
                                Recording Person
                              </td>
                              <td className="text-dark" width="1" />
                              <td>
                                {_.get(item, 'attributes.recording_person') ||
                                  '--'}
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="span-title2 font-weight-bold"
                                width="250"
                              >
                                Date
                              </td>
                              <td className="text-dark" width="1" />
                              <td>{_.get(item, 'attributes.date') || '--'}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </React.Fragment>
                );
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
LandSupersededAssessment.defaultProps = {
  type: '',
  applicationId: '',
  applicationType: '',
  applicationStatus: '',
  historyApplicationId: '',
};

LandSupersededAssessment.propTypes = {
  getSingleLandRecordofSupAssessment: PropTypes.instanceOf(Function).isRequired,
  getLandRecordofSupAssessmentList: PropTypes.instanceOf(Function).isRequired,
  getHistoryRecordofSupAssessmentList:
    PropTypes.instanceOf(Function).isRequired,
  applicationId: PropTypes.string,
  applicationType: PropTypes.string,
  applicationStatus: PropTypes.string,
  historyApplicationId: PropTypes.string,
  removeLandRecordofSupAssessment: PropTypes.instanceOf(Function).isRequired,
  landSupersededAssessmentInfo: PropTypes.instanceOf(Object).isRequired,
  dataList: PropTypes.instanceOf(Array).isRequired,
  type: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  dataList: _.get(api, `${c.GET_LAND_RECORD_OF_SUP_ASSESSMENT}.list`) || [],
  landSupersededAssessmentInfo:
    _.get(api, `${c.GET_SINGLE_LAND_RECORD_OF_SUP_ASSESSMENT}.item`) || {},
  isLoading:
    _.get(api, 'loading', []).indexOf(c.GET_LAND_RECORD_OF_SUP_ASSESSMENT) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(LandSupersededAssessment);
